let id = 0;

export default () => `${id++}`;
